module.exports = __webpack_public_path__ + "img/ads-icon-dark.385835a5.svg";